(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('DataSource', dataSourceFactory);

    var extend = angular.extend,
        noop = angular.noop,
        isArray = angular.isArray;

    dataSourceFactory.$inject = [];
    function dataSourceFactory() {
        var current,
            defaults = {
                data: [],
                page: 1,
                pageSize: 10,
                sort: null,
                filter: null,
                read: noop,
                params: {}
            };

        return function DataSource(options) {
            // Variables
            options = extend({}, defaults, options);

            // Properties
            Object.defineProperties(this, {
                // Data
                data: { get: getData, set: setData },
                view: { get: getView },

                // Page
                page: { get: getPage, set: setPage },
                pageSize: { get: getPageSize, set: setPageSize },
                pageCount: { get: getPageCount },

                // Index
                startIndex: { get: getStartIndex },
                endIndex: { get: getEndIndex },
                total: { get: getTotal },

                // Sort
                sort: { get: getSort, set: setSort },

                // Filter
                filter: { get: getFilter, set: setFilter }
            });

            // Methods
            this.read = read;
            this.seek = seek;
            this.first = seek.bind(this, 0, 'begin');
            this.previous = seek.bind(this, -1, 'current');
            this.next = seek.bind(this, 1, 'current');
            this.last = seek.bind(this, 0, 'end');

            //////////////////////////////////////////

            // Data Accessors
            function getData() {
                return options.data;
            }
            function setData(value) {
                options.data = value;

                // If they filtered they may be on a page that no longer exists.
                // Pick last page available.  Hopefully, this won't cause an endless loop.
                if (this.page > this.pageCount)
                    this.page = this.pageCount;
            }

            function getView() {
                return isArray(this.data) ? this.data : this.data && isArray(this.data.data) ? this.data.data : [];
            }


            // Page Accessors
            function getPage() {
                return options.page;
            }
            function setPage(value) {
                this.read({ page: Math.max(Math.min(value, this.pageCount), 1) });
            }

            function getPageSize() {
                return options.pageSize;
            }
            function setPageSize(value) {
                this.read({ pageSize: Math.max(1, value) });
            }

            function getPageCount() {
                return Math.max(Math.ceil(this.total / this.pageSize), 1);
            }

            // Index Accessors
            function getStartIndex() {
                return (this.page - 1) * this.pageSize || 0;
            }
            function getEndIndex() {
                return Math.min(this.startIndex + this.pageSize, this.total);
            }
            function getTotal() {
                var data = options.data;
                return data && (data.length || data.total) || 0;
            }

            // Sort Accessors
            function getSort() {
                return options.sort;
            }

            function setSort(value) {
                this.read({ sort: value });
            }

            // Filter Accessors
            function getFilter() {
                return options.filter;
            }
            function setFilter(value) {
                this.read({ filter: value });
            }

            // Methods
            function read(opts) {
                var that = this,
                    opts = extend({}, options, opts),
                    params = extend({}, opts.params),
                    dataSource = new DataSource(opts),
                    promise;

                if (dataSource.pageSize != null)
                    params.$top = dataSource.pageSize
                if (dataSource.startIndex != null)
                    params.$skip = dataSource.startIndex;
                if (dataSource.sort != null)
                    params.$orderby = dataSource.sort.field + ' ' + dataSource.sort.dir;
                if (dataSource.filter != null)
                    params.$filter = this.filter;

                if (current && current.$cancelRequest)
                    current.$cancelRequest();
                current = opts.read.call(this, params);

                promise = current && current.$promise || current;
                if (promise && promise.then)
                    promise.then(success);

                function success(data) {
                    options = opts;
                    that.data = data;
                }
            }

            function seek(offset, origin) {
                var base = origin === 'begin' ? 1 : origin === 'end' ? this.pageCount : this.page;
                this.page = base + offset;
            }
        }
    }
})();